import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent } from "vue";
export default defineComponent({
  name: "ExperienceSelector",
  components: {
    // components
  },
  setup: function setup() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log('<<<<<<<<< ExperienceSelector mounted >>>>>>>>>');
            _this.quick();
            _this.$store.dispatch('crazyEggStartRecording');
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    // "$store.state.permission_location": "handleLocationPermissionsChange"
    // // "$store.state.queuedCloudTTSSentences": "processCloudTTSPayloads",
  },
  props: {},
  data: function data() {
    return {
      rating: 0
      // data
    };
  },
  methods: {
    immersive: function immersive() {
      // this.$store.dispatch('crazyEggStopRecording');
      this.$store.commit('updateShowExperienceSelector', false);
      this.$store.commit("updateShowMainApplication", true);
      this.$store.commit("updateShowImmersiveIntro", true);
      // this.$store.dispatch("registerActionEvent", {
      //   action: "ExperienceSelector",
      //   data: 'Immersive',
      // });
    },
    quick: function quick() {
      // this.$store.dispatch('crazyEggStopRecording');
      this.$store.commit('updateShowExperienceSelector', false);
      this.$store.commit("updateShowMainApplication", true);
      this.$store.commit("updateShowQuickIntro", true);
      // this.$store.dispatch("registerActionEvent", {
      //   action: "ExperienceSelector",
      //   data: 'Quick',
      // });
    }
  }
});